import React from "react";
import { Box } from "@mui/material";
import { filterRangeValue } from "../../../api_calls/TableauVisuals";
import { StickyTopRowStack, StickyTopRowStackSpaceBetween } from "../../../components/commonComponents/StyledComponents/styled";
import StoreFilter from "../../../components/commonComponents/Filters/StoreFilter";
import DateRangeFilter from "../../../components/commonComponents/Filters/DateRangeFilter";
import SingleSelectStoreFilter from "../../../components/commonComponents/Filters/SingleSelectStoreFilter";
import { useSelector } from "react-redux";
import {
  dbFormatDate,
  formatToStandardDate,
  resetBrandReportView,
  standardFormatToday,
  storeListOptionsForFilter,
  yesterdayDate,
} from "../../../api_calls/utils";
import DateRangeInputFields from "../../../components/commonComponents/Filters/DateRangeInputFields";

const RetailAnalyticsFilter = ({ singleStore, usedFor, reduxKeyForStore, reduxKeyForDate }) => {
  const userStateDate = useSelector((state) => state.userSelections);
  let filtersUsedFor = typeof usedFor !== "undefined" ? usedFor : "retail-analytics";
  const { date_range_start_date, date_range_end_date } = userStateDate;

  const { minSelectableDate, maxSelectableDate } = React.useMemo(() => {
    const today = standardFormatToday();
    const yesterday = new Date(today);
    yesterday.setDate(today.getDate() - 1);

    const start = date_range_start_date
      ? new Date(date_range_start_date)
      : new Date("2023-02-07");

    const end = date_range_end_date
      ? new Date(date_range_end_date)
      : dbFormatDate(yesterday);

    return {
      minSelectableDate: start,
      maxSelectableDate: end,
    };
  }, [date_range_start_date, date_range_end_date]);

  return (
    <StickyTopRowStackSpaceBetween
      direction={"row"}
      spacing={1}
      sx={{
        justifyContent: "flex-end",
      }}
    >
      <Box sx={{ display: "flex", flexDirection: "row", justifyContent: "flex-end", ml: "auto" }}>
        {/* ------- stores filter ----------- */}
        <Box sx={{ width: 250 }}>
          {/* <StoreFilter fieldName={"Name Store"} usedFor={"retail"} vizId={tabVizId} /> */}
          {typeof singleStore !== "undefined" && singleStore === true ? (
            <SingleSelectStoreFilter
              usedFor={filtersUsedFor}
              reduxKeywordToSaveValue={reduxKeyForStore}
            />
          ) : (
            <StoreFilter
              usedFor={filtersUsedFor}
              reduxKeywordToSaveValue={reduxKeyForStore}
            />
          )}
        </Box>
        {/* ------------ day timestamp filter ------------ */}
        {typeof userStateDate.date_range_start_date !== "undefined" && (
          <Box>
            <DateRangeInputFields
              minSelectableDate={minSelectableDate}
              maxSelectableDate={maxSelectableDate}
              reduxKeywordToSaveValue={reduxKeyForDate}
            />
          </Box>
        )}
      </Box>

    </StickyTopRowStackSpaceBetween>
  );
};

export default RetailAnalyticsFilter;
